import isEmpty from 'lodash.isempty';
import { format } from 'date-fns';
import { getAssessmentDate as getSharedAssessmentDate } from '../shared/trcUtils';
import { MEASURE } from '../../constants/reading/MeasuresConstants';
import { DATE_FORMAT } from '../../constants/shared/CommonConstants';

const { TRO } = MEASURE;

const getAssessmentDate = (result, location) => {
    const { measure, modifiedDate } = result;
    return measure === TRO && !isEmpty(modifiedDate)
        ? format(new Date(modifiedDate), DATE_FORMAT.FULL_DATE)
        : getSharedAssessmentDate(result, location);
};

export default getAssessmentDate;
